<template>
	<db-row width="auto" height="auto" class="step-wrapper">
		<db-col v-for="(item, idx) in items" :key="idx" height="auto" class="pd-bottom-30">
			<db-col width="40" height="40" class="step-circle" :class="['step-circle--' + item.chose, 'line--' + item.pos]" valign="middle" align="center">
				<db-icon icon="check" color="#FFFFFF" v-if="item.chose" />
				<db-label v-else>{{idx + 1}}</db-label>
			</db-col>
			<db-row height="auto">
				<db-label size="28" bold :color="item.chose ? '#333333' : '#999999'">{{item.title}}</db-label>
				<db-label v-if="item.sub" size="24" color="#999999" class="mg-top-6">{{item.sub}}</db-label>
			</db-row>
		</db-col>
	</db-row>
</template>

<script>
	export default {
		name: 'step_',
		
		props: {
			list: {
				type: Array,
				default(){
					return []
				}
			},
			
			value: {
				type: [String, Number],
				default: 0
			}
		},
		
		computed: {
			items(){
				return this.list.map((item, idx) => {
					if(idx === 0){
						item.pos = 'first'
					}else if(idx !== this.list.length - 1){
						item.pos = 'mid'
					}else{
						item.pos = 'end'
					}
					this.$set(item, 'chose', idx === Number.parseInt(this.value))
					return item
				})
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.step-wrapper{
		
		.step-circle{
			position: relative;
			border-radius: 120px;
			margin-right: 16px;
			
			&.step-circle--true{
				background: #2373EB;
				color: #FFFFFF;
			}
			
			&.step-circle--false{
				border: solid 1px #CCCCCC;
				background: #FFFFFF;
				color: #CCCCCC;
			}
			
			&.line--first{
				&::after{
					position: absolute;
					top: 40px;
					left: 19px;
					content: '';
					width: 2px;
					height: 200%;
					background: #DCDCDC;
				}
			}
			&.line--mid{
				&::after{
					position: absolute;
					top: 38px;
					left: 19px;
					content: '';
					width: 2px;
					height: 200%;
					background: #DCDCDC;
				}
			}
		}
		
		.pd-bottom-30{
			padding-bottom: 30px;
		}
		
		.mg-top-6{
			margin-top: 12px;
		}
	}
</style>
